export const StubPage = ({ name, description }) => (
  <div class="surface-card max-w-2xl p-6">
    <h1 class="m-0 mb-2 font-serif text-2xl font-medium text-text-primary">{name}</h1>
    <p class="m-0 mb-4 text-sm text-text-secondary">{description}</p>
    <p class="m-0 text-sm font-semibold text-brand">Not yet implemented.</p>
  </div>
);
